import { render, staticRenderFns } from "./DetailKYC.vue?vue&type=template&id=4f5b427d&scoped=true"
import script from "./DetailKYC.vue?vue&type=script&lang=js"
export * from "./DetailKYC.vue?vue&type=script&lang=js"
import style0 from "./DetailKYC.vue?vue&type=style&index=0&id=4f5b427d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b427d",
  null
  
)

export default component.exports